import React from 'react';
import I18n from 'i18n-js';
import {
  Shop,
  core_apimessages_Channel,
} from '../../schemas/rql';
import URLHelpers from '../shared/url_helpers';

interface IProps {
  shop?: Shop;
  userName?: string;
  channel?: core_apimessages_Channel;
}

export default class FeedbackShopLink extends React.Component<IProps, null> {
  renderShopLink() {
    const { shop } = this.props;

    if (this.props.channel === core_apimessages_Channel.LP) {
      return shop.name;
    }

    return (
      <a
        className="shop-icon-link"
        href={URLHelpers.shopPath(shop.slug)}
      >
        {shop.name}
      </a>
    );
  }

  render() {
    return (
      <div>
        <span className="strong">
          {I18n.t('discovery.feedbackShopInfo.leavingFeedbackFor')}
        </span>
        <p className="strong">
          {this.props.shop ? this.renderShopLink() : this.props.userName}
        </p>
      </div>
    );
  }
}
